import { SVGProps } from 'react'

export const Accept = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="none" viewBox="0 0 36 36" {...props}>
    <rect width="36" height="36" fill="#3A79E0" rx="18"></rect>
    <path fill="#fff" d="M15.33 21.229l-3.476-3.475-1.183 1.175 4.658 4.658 10-10-1.175-1.175-8.825 8.817z"></path>
  </svg>
)
